import { Component, OnInit, ViewChild, Input, Renderer2 } from "@angular/core";
import { ApiserviceService } from "../..//httpservice/apiservice.service";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";
import { IResponse } from "./tpye";
import { AlertController, IonInput, LoadingController } from "@ionic/angular";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { STORAGE } from "../../constant/storages";
import { ROUTE } from "../../constant/routes";
import { _deleteStorage, _getStorage, _setStorage } from "../../utils/local-storage";
import { errMsg } from "../../text_control/error-msg";
import { BTN } from "../../text_control/text_button";
import { TEXT as KEYTEXT } from "../../text_control";

export interface Fruit {
  numbers: string;
}

@Component({
  selector: "app-tax-invoice",
  templateUrl: "./tax-invoice.component.html",
  styleUrls: ["./tax-invoice.component.scss"],
})
export class TaxInvoiceComponent implements OnInit {
  @ViewChild("showFont") showFonts: IonInput;
  @ViewChild("showNumber") showNumbers: IonInput;
  @Input() public appAutoFocus: boolean;
  actice = 1;
  phone: any = "";
  taxid: any = "";
  company_name: any = "";
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  showNumber = false;
  showString = false;
  showFont = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[] = [];

  keyText: any;
  text_btn: any;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = ""

  constructor(
    public apiservice: ApiserviceService,
    public appService: AppService,
    public route: Router,
    public alertController: AlertController,
    public app: AppService,
    private renderer: Renderer2,
    public loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    
    this.keyText = KEYTEXT;
    this.text_btn = BTN;
  }
  ngOnInit() {}
  focusMyInput() {
    this.renderer.selectRootElement("#showString").focus();
  }
  ionViewWillEnter() {
   

    this.appService.setActive(1);
    this.app.resetdata();
    this.phone = "";
    this.fruits = [];
    this.taxid = "";
    this.taxid1 = "";
    this.company_name = "";
    this.showFont = true;
    this.showString = false;
    this.showNumber = false;
    _deleteStorage(STORAGE.DATA_CREATEFULLTAX);
    _deleteStorage(STORAGE.DATA_SELECTTAXINVOICE);
    _deleteStorage(STORAGE.DATA_ABB);
    _deleteStorage(STORAGE.DATA_EDIT);
    _deleteStorage(STORAGE.DATA_PREVIEW_TAXINVOICE);
  }

  async checkphone(e, n) {
    let phone = [];
    phone = this.phone;
    if (e.code && e.code.toUpperCase() === "ENTER") {
      if (phone.length != 10 && phone.length != 9) {
        const alert = await this.alertController.create({
          cssClass: "my-confirm-phone",
          message: errMsg.pleasePhone,
        });
        await alert.present();
        setTimeout(() => {
          alert.dismiss(true);
          this.fruits = this.fruits.slice(0, -1);
        }, 1500);
      }
    } else {
      if (n == 1) {
        this.phone = e.target.value.match(/[0-9]*/)[0];
      }
    }
  }

  add(e: MatChipInputEvent): void {
    this.checkphone({ code: "ENTER", key: " " }, 1);
    const input = e.input;
    const value = e.value;
    if ((value || "").trim()) {
      this.fruits.push({ numbers: value.trim() });
    }
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
      this.phone = "";
    }
  }

  checkinput(e) {
    if (e.target.value === "") {
      this.showString = false;
      this.showNumber = false;
      this.showFont = true;
      this.taxid = "";
      this.taxid1 = "";
      setTimeout(() => {
        let elem = this.renderer.selectRootElement("#showFont");
        elem.focus();
      }, 10);
      return;
    }
    if (isNaN(e.target.value)) {
      this.showString = true;
      this.showNumber = false;
      this.showFont = false;
      if (this.taxid !== "") {
        this.taxid1 = this.taxid;
      }
      this.taxid = "";
      setTimeout(() => {
        let elem = this.renderer.selectRootElement("#showString");
        elem.focus();
      }, 10);
    } else if (!isNaN(e.target.value)) {
      this.showString = false;
      this.showNumber = true;
      this.showFont = false;
      this.taxid1 = "";
      setTimeout(() => {
        let elem = this.renderer.selectRootElement("#showNumber");
        elem.focus();
      }, 10);
    }
  }

  async refresh() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please refresh...",
    });
    await loading.present();
    setTimeout(async () => {
      this.taxid = "";
      this.taxid1 = "";
      this.phone = "";
      this.fruits = [];
      this.company_name = "";
      this.showFont = true;
      this.showString = false;
      this.showNumber = false;
      await loading.dismiss();
    }, 2000);
  }

  datasearch: any;
  count = 0;
  taxid1: any;
  async search() {
    let isConfirm: boolean = false;
    let phone = String(this.phone);
    let taxid = String(this.taxid);
    let company_name = String(this.company_name);
    let phones = [];

    for (let i of this.fruits) {
      phones.push(i.numbers);
    }
    if (!isConfirm) {
      if (
        phone === "" &&
        taxid === "" &&
        company_name === "" &&
        this.taxid1 === ""
      ) {
        this.ErrorMsg(errMsg.pleaseInput);
        return;
      }
      if (taxid !== "" && taxid.length != 13) {
        this.ErrorMsg(errMsg.buyer_tax_id);
        return;
      }
      if (taxid !== "" && !this.appService.checkIdentityCardNumber(taxid)) {
        this.ErrorMsg(errMsg.card_tax);
        return;
      }
      if (this.taxid1 !== "") {
        this.taxid = this.taxid1;
      }
      isConfirm = true;
    }

    if (isConfirm) {
      const req = {
        searchCustomerData: {
          phone: phones,
          taxid: this.taxid,
          company_name: this.company_name,
          userBu: this.userBu,
          userLoc: this.userLoc,
          userRole: this.userRole,
          user_id: this.userID,
          userSource: this.userSource

        },
      };
      console.log("======= req search taxinvoice =======", req);

      try {
        const res: IResponse = await this.apiservice._post(
          this.apiservice.apiUrl + this.apiservice.searchcustomer,
          req
        );
        console.log("======= res search taxinvoice =======", res);

        if (res.statusCode === 200) {
          this.appService.setActive(2);
          _setStorage(STORAGE.DATA_SELECTTAXINVOICE, res.data);
          this.route.navigate([ROUTE.TAXINVOICE_SELECT]);
        } else if (res.statusCode === 204) {
          this.appService.setActive(2);
          this.route.navigate([ROUTE.TAXINVOICE_SELECT]);
          _setStorage(STORAGE.DATA_SELECTTAXINVOICE, res.data);
          const data = {
            buyer_company_name: req.searchCustomerData.company_name,
            buyer_tax_id: req.searchCustomerData.taxid,
            buyer_branch_no: "",
            template_lang: "TH",
            buyer_agree_tmp: "Y",
            address_detail: [{ phone: req.searchCustomerData.phone.join(",") }],
          };
          _setStorage(STORAGE.DATA_CREATEFULLTAX, data);
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      } catch (error) {
        // this.ErrorMsg(errMsg.error)
      }
    }
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
